<template>
  <div class="about">
    <div class="box">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="General" name="general"></el-tab-pane>
        <el-tab-pane label="About Our Organisation" name="about"></el-tab-pane>
        <el-tab-pane label="Business & Accounting" name="businessAccounting"></el-tab-pane>
        <el-tab-pane label="Taxation" name="taxation"></el-tab-pane>
        <el-tab-pane label="Reporting" name="reporting"></el-tab-pane>
        <el-tab-pane label="Statutory" name="statutory"></el-tab-pane>
        <el-tab-pane label="Owners" name="owners"></el-tab-pane>
        <el-tab-pane label="Directors & Officers" name="directorsAndOfficers"></el-tab-pane>
      </el-tabs>
      <div v-if="activeTab === 'general'">
        <general-content />
      </div>
      <div v-if="activeTab === 'about'">
        <about-our-organisation />
      </div>
      <div v-if="activeTab === 'taxation'">
        <taxation-content />
      </div>
      <div v-if="activeTab === 'reporting'">
        <reporting-content />
      </div>
      <div v-if="activeTab === 'statutory'">
        <statutory-content />
      </div>
      <div v-if="activeTab === 'businessAccounting'">
        <business-accounting-content />
      </div>
    </div>


    <!-- <div class="content">

      <div class="wrap">

        <div class="wrap__info">
          <el-table
            :data="company"
            :show-header="false"
            style="width: 100%">
            <el-table-column
              prop="title"
              label="Title">
            </el-table-column>
            <el-table-column
              label="Data">
              <template slot-scope="scope">
                <div v-if="scope.row.data.length > 8">
                  <div v-if="scope.row.data.slice(0, 7) == 'http://' || scope.row.data.slice(0, 8) == 'https://'">
                    <a :href="scope.row.data" target="_blank">{{scope.row.data}}</a>
                  </div>
                  <div v-else>
                    {{scope.row.data}}
                  </div>
                </div>
                <div v-else>
                  {{scope.row.data}}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="wrap__map">
          <iframe width="100%" height="100%" id="gmap_canvas" :src="map" frameborder="0" scrolling="no" marginheight="0" marginwidth="0"></iframe>
        </div>

      </div>
    </div> -->

  </div>
</template>

<script>
import { SweetModal } from '@totalflow4/tfsweet-modal-vue'
import axios from 'axios'
import ReportingContent from "../components/about/reporting/ReportingContent";
import TaxationContent from "../components/about/taxation/TaxationContent";
import StatutoryContent from "../components/about/statutory/StatutoryContent";
import BusinessAccountingContent from "../components/about/businessAccounting/BusinessAccountingContent";
import GeneralContent from "../components/about/general/GeneralContent";
import AboutOurOrganisation from "../components/about/about/AboutOurOrganisation";
export default {
  name: 'about',
  components: {
    TaxationContent,
    ReportingContent,
    SweetModal,
    StatutoryContent,
    BusinessAccountingContent,
    GeneralContent,
    AboutOurOrganisation,
  },
  created() {
    let loader = this.$loading.show();
    axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.getItem('token');
    axios.defaults.headers.common['X-Timezone-Offset'] = ((new Date()).getTimezoneOffset() / 60).toString();
    axios
      .post(`/api/v1/companies/info?companyId=${this.$route.query.companyId}`)
      .then(response => {
        console.log('---/companies/info', response.data.info);
        this.expandedInformation = response.data.info.additionalInfo
        this.statutoryInformation = response.data.info.statutoryInfo

        let customFieldsJson = JSON.parse(response.data.info.customFieldsJson)

        for (let i in customFieldsJson) {
          let obj = {
            title: null,
            data: null,
          }

          switch (i) {
            case 'organization':
              obj.title = this.$t('about_organization')
              break;
            case 'tradingName':
              obj.title = this.$t('about_trading_name')
              break;
            case 'businessType':
              obj.title = this.$t('about_business_type')
              break;
            case 'startedOn':
              obj.title = this.$t('about_started_on')
              break;
            case 'website':
              obj.title = this.$t('about_website')
              break;
            case 'businessDomain':
              obj.title = this.$t('about_business_domain')
              break;
            case 'fax':
              obj.title = this.$t('about_fax')
              break;
            case 'totalEmployess':
              obj.title = this.$t('about_total_employess')
              break;
            case 'primaryPhone':
              obj.title = this.$t('about_phone')
              break;
            case 'taxNumber':
              obj.title = this.$t('about_tax_number')
              break;
          }
          if (customFieldsJson[i] === null) {
            obj.data = ''
          } else {
            obj.data = customFieldsJson[i]
          }

          this.company.push(obj)
        }
        this.company.push({title: this.$t('about_email'), data: response.data.info.email})
        if (response.data.info.country) {
          this.company.push({title: this.$t('about_country'), data: response.data.info.country.name})
        } else {
          this.company.push({title: this.$t('about_country'), data: ''})
        }
        if (response.data.info.state) {
          this.company.push({title: this.$t('about_state'), data: response.data.info.state.name})
        } else {
          this.company.push({title: this.$t('about_state'), data: ''})
        }
        if (response.data.info.city) {
          this.company.push({title: this.$t('about_city'), data: response.data.info.city.name})
        } else {
          this.company.push({title: this.$t('about_city'), data: ''})
        }
        if (response.data.info.postCode) {
          this.company.push({title: this.$t('about_post_code'), data: response.data.info.postCode})
        } else {
          this.company.push({title: this.$t('about_post_code'), data: ''})
        }
        if (response.data.info.address) {
          this.company.push({title: this.$t('about_address_line_1'), data: response.data.info.address})
        } else {
          this.company.push({title: this.$t('about_address_line_1'), data: ''})
        }
        if (response.data.info.address2) {
          this.company.push({title: this.$t('about_address_line_2'), data: response.data.info.address2})
        } else {
          this.company.push({title: this.$t('about_address_line_2'), data: ''})
        }
        if (response.data.info.address3) {
          this.company.push({title: this.$t('about_address_line_3'), data: response.data.info.address3})
        } else {
          this.company.push({title: this.$t('about_address_line_3'), data: ''})
        }

        this.map = 'https://maps.google.com/maps?q=' + response.data.info.country.name + ',' + response.data.info.state.name + ',' + response.data.info.city.name + ',' + response.data.info.address + ',' + response.data.info.address2 + ',' + response.data.info.address3 + '&t=&z=13&ie=UTF8&iwloc=&output=embed'
        loader.hide()
      })
      .catch(error => {
        console.log('An error occurred:', error);
        loader.hide()
      });
  },
  data() {
    return {
      // open: false,
      companyNameSelect: '',

      companyNameTitle: '',
      company: [],
      map: '',

      expandedInformation: [],
      statutoryInformation: [],
      activeTab: 'general',
    }
  },
  methods: {
    notification(title, message, type) {
      this.$notify({
        title: title,
        message: message,
        type: type
      });
    },
  },
}
</script>

<style lang="scss" scoped>
.about {
  // background: #DfE8F0;
  background: #fff;
  height: 100vh;
  padding-top: 60px;
}

.box  {
  padding: 0px 10px;
  &__title {
    color: #409EFF;
  }
}

.text {
  font-size: 18px;
  font-weight: bold;
}

.content {
  // display: flex;
  height: 100vh;
  padding-top: 50px;
}

// [ Wrapper ] start
.wrap {
  display: flex;
  width: 100%;
  padding: 10px 10px 10px 10px;
  &__title {
    color: #909399;
    font-size: 36px;
    margin-bottom: 10px;
  }
}
// [ Wrapper ] end

// [ Info ] start
.wrap__info {
  width: 45%;
  padding: 0 10px 10px 0;
}
// [ Info ] end

// [ Map ] start
.wrap__map {
  width: 100%;
  height: 200px;
  padding: 0 0 0 0;
}
.user-info {
  &__title {
    margin-top: 0;
  }
  &__content {
    display: flex;
  }
  &__photo {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-right: 20px;
    background: url('~@/assets/img/user-default.jpg');
    background-size: cover;
    img {
      width: 150px;
      height: 150px;
      border-radius: 50%;
      // background: url('~@/assets/img/user-default.jpg');
      background-size: cover;
    }
  }
  &__details {
    &_label {
      display: inline-block;
      width: 100px;
    }
    ul {
      margin: 0;
      padding: 0;
      list-style: none;
      color: #909399;
      li {
        margin-bottom: 8px;
        span {
          font-weight: 500;
        }
      }
    }
    &_email {
      font-weight: bold;
      background: #888;
      color: white;
      border-radius: 5px;
      padding: 3px;
    }
    &_status {
      font-weight: bold;
      background: #5cb85c;
      color: white;
      border-radius: 5px;
      padding: 3px;
    }
    &_all {
      font-weight: bold;
    }
  }
}
// [ Map ] end

// [ Modal ] start
.modal {
  &__title {
    text-align: center;
  }
  &__btn {
    text-align: center;
  }
}
// [ Modal ] end
// [ Reinvite Modal ] start
  .reinvite-btn{
    display:flex;
    justify-content:center;
  }
//[ Reinvite Modal ] end
// [ Nav tree ] start
.nav-tree {
  padding-bottom: 10px;
  &__item {
    margin: 0 0 5px 0;
  }
  .el-button {
    margin-right: 10px;
  }
}
// [ Nav tree ] end
</style>
